/* eslint-disable */
import {lista, nao_autorizado, pegaDados, pegaLista, processaArquivo, processar, processarGet} from '../../services/GenericAPI';
import { Parametro } from '../../models/parametro'; // Modelo da tabela Parametro
import { Filtro } from "../../models/filtro/filtro";
import { BaseDescSCH, getBaseSCH } from "../../search/BaseSCH";

const url = '/sincronizar';

const state = {
   all: [],
   progresso: 0,
   percentual: 0,
   consultarStatus: null,
   timer: null,
   jobId: null,
   sincronizando: false,
   mensagem: "",
};

const getters = {
   pegaProgresso(){
      return state.progresso
   }
 };

const actions = {
   async stopSincronizar({commit}, {filtro,onSucesso,onErro}) {
      try {
         const list = (await processar(url + '/stop_sincronizar', filtro))
         onSucesso(list)
      } catch (error) {
         onErro()
         console.log('error: ',error)
         this.dispatch('geral/setObjMsgError', error.response.data)
      }
   },
   async startSincronizar({commit}, {filtro,onSucesso,onErro}) {
      try {
         console.log('startSincronizar');
         const list = (await processar(url + '/commit', filtro,'gravar'))
         onSucesso(list.data)
      } catch (error) {
         onErro()
         console.log('error: ',error)
         this.dispatch('geral/setObjMsgError', error.response.data)
      }
   },
   async stopCommit({commit}, {filtro,onSucesso,onErro}) {
      try {
         console.log('stopSincronizar');
         const list = (await processar(url + '/stopCommit', filtro,'gravar'))
         onSucesso(list.data)
      } catch (error) {
         onErro()
         console.log('error: ',error)
         this.dispatch('geral/setObjMsgError', error.response.data)
      }
   },



   async atualizarProgresso({ commit, dispatch }) {
      console.log('atualizarProgresso');
      const interval = setInterval(async () => {
         try {
            const response = (await pegaDados(url + '/get_progresso', [])).data;
            console.log(response);
            commit("SET_PROGRESO", response.progress);

            if (response.progress >= 100) {
               clearInterval(interval);
               commit("SET_MENSAGEM", "Sincronização concluída!");
               commit("SET_SINCRONIZANDO", false);
            }
         } catch (error) {
            commit("SET_MENSAGEM", "Erro ao obter progresso.");
            clearInterval(interval);
            commit("SET_SINCRONIZANDO", false);
         }
      }, 1000);
   },

   async getProgress({ commit }, { onSucesso, onErro }) {
      try {


         // Inicia a sincronização no backend
         const response = (await pegaDados(url + '/get_progresso', [])).data;
         onSucesso(response)
         // Atualiza a barra de progresso periodicamente
         const interval = setInterval(async () => {
            const response = (await pegaDados(url + '/get_progresso', [])).data;
            state.progresso = response.progress;

            if (state.progresso >= 100) {
               onSucesso(response)
               clearInterval(interval);
            }
         }, 1000);



      } catch (error) {
         onErro();
         console.log(error);
      }
   },

   async processar_array({ commit }, { onSucesso, onErro }) {
      try {
         console.log('processarSincronia');
         let res = await processar(url +'/commit', state.parametro, 'gravar');
         onSucesso(res);
      } catch (error)      {
         onErro();
         console.log('error: ', error);
         this.dispatch('geral/setObjMsgError', error.response.data);
      }
   },

   async processarSincronia({ commit }, { onSucesso, onErro }) {
      try {
         console.log('processarSincronia');
         let res = await processar(url +'/commit', state.parametro, 'gravar');
         onSucesso(res);
      } catch (error)      {
         onErro();
         console.log('error: ', error);
         this.dispatch('geral/setObjMsgError', error.response.data);
      }
   },

   async gerarListaClientesPdf({ commit }, { onSucesso, onErro }) {
      try {
         console.log('gerarListaClientesPdf');

         let res =  (await pegaDados(url+'/get_cliente_list', []));
         const urlB = window.URL.createObjectURL(
          new Blob([res.data], { type: 'text/csv;charset=utf-8;' })
         )

         const link = document.createElement('a')
         link.href = urlB
         link.setAttribute('download', 'clientes.csv')
         document.body.appendChild(link)
         link.click()

         link.remove()
         window.URL.revokeObjectURL(urlB)

         // const { data } = await this.$axios.post('/clientes-topsap/pdf')

         // state.timer = setInterval(state.consultarStatus,2000)
         // state.jobId = data.job_id


         onSucesso(res);
      } catch (error)      {
         onErro();
         console.log('error: ', error);
         this.dispatch('geral/setObjMsgError', error.response.data);
      }
   },

   async consultarStatus() {
      console.log('consultarStatus');
      const {data} = (await processarGet('/clientes-topsap/pdf', {jobId:state.jobId}));
      // const { data } = await this.$axios.get(`/clientes-topsap/pdf/${state.jobId}`)

      state.percentual = data.percentual

      if (data.status === 'concluido') {

         clearInterval(state.timer)

         window.open(data.arquivo, '_blank')
      }
   }



};

const mutations = {
   SET_PROGRESO(state, progresso) {
      state.progresso = progresso;
   },
   SET_SINCRONIZANDO(state, status) {
      state.sincronizando = status;
   },
   SET_MENSAGEM(state, mensagem) {
      state.mensagem = mensagem;
   }
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations
};
